<template>
  <div>
    <div class="ad" v-if="adMsg.is_show && curNav == '/home' && adState == true" :class="isFixed ? 'active' : null">
      <a class="ad-img" :href="adMsg.link">
        <img :src="adMsg.cover" alt="" />
        <a class="ad-close" href="javascript:;" @click.stop="closeAd">
          <img src="../assets/img/icon-close.png" alt="" />
        </a>
      </a>
    </div>
    <div id="header" class="container-fuild" :class="[
      isFixed ? 'active' : null,
      adMsg.is_show && curNav == '/home' && adState == true ? 'top' : null,
    ]">
      <!-- 电脑导航 -->
      <div class="container pc-nav">
        <a class="nav-logo" href="/">
          <img src="@/assets/img/logo.png" v-if="!isFixed" />
          <img src="@/assets/img/logo2.png" v-else />
        </a>
        <ul class="nav-wrapper">
          <li v-for="(item, index) in navList" :key="index" :class="item.uri == curNav ? 'active' : ''"
            @click="navClick(index, item)">
            <template v-if="item.is_show == 1">
              <router-link :to="item.uri">
                {{ item.name }}
                <span v-if="item.children.length > 0" class="glyphicon glyphicon-menu-down"></span>
                <i class="underline"></i>
              </router-link>

              <dl v-if="item.children.length > 0">
                <dt v-for="(i, n) in item.children" :key="n">
                  <template v-if="i.is_show == 1">
                    <a target="_blank" :href="i.uri" v-if="!i.uri.indexOf('http')">{{
                        i.name
                    }}</a>
                    <router-link :to="i.uri" v-else>{{ i.name }}</router-link>
                  </template>
                </dt>
              </dl>
            </template>
          </li>
        </ul>
      </div>

      <!-- 手机导航 -->
      <div class="header-m">
        <a href="javascript:;" class="logo">
          <img src="@/assets/img/logo-m.png" />
        </a>
        <div class="m-menu-b"></div>
        <div class="m-menu">
          <ul class="nav">
            <li class="cur" v-for="(item, index) in navList" :key="index">
              <template v-if="item.is_show == 1">
                <router-link :to="item.uri">{{ item.name }}</router-link>
                <div class="sub-nav-extend" v-if="item.children.length > 0" @click.stop="extendSubMenu(item)"></div>
                <ul class="sub-nav" :class="curSubNav == item.id ? 'active' : null" v-if="item.children.length > 0">
                  <li v-for="(i, n) in item.children" :key="n">
                    <template v-if="i.is_show == 1">
                      <a target="_blank" :href="i.uri" v-if="!i.uri.indexOf('http')">{{
                          i.name
                      }}</a>
                      <router-link :to="i.uri" v-else>{{ i.name }}</router-link>
                    </template>
                  </li>
                </ul>
              </template>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div id="banner">
      <div class="swiper-container banner banner-swiper" :class="curNav == '/home' ? 'index' : null"
        v-if="bannerList.length > 0">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in bannerList" :key="index">
            <video class="swiper-slide-video" :src="item.video" v-if="item.video" muted autoplay preload="auto"></video>
            <img class="swiper-slide-image" :src="item.cover" v-else />
          </div>
        </div>
        <div class="swiper-pagination" v-if="bannerList.length > 0"></div>
        <div class="swiper-button-prev" v-if="bannerList.length > 0"></div>
        <div class="swiper-button-next" v-if="bannerList.length > 0"></div>
      </div>

      <div class="swiper-container banner banner-swiper" :class="curNav == '/home' ? 'index' : null" v-else>
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img class="swiper-slide-image" src="../assets/img/index/banner1.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
var bannerSwiper = "";
export default {
  name: "Header",
  data() {
    return {
      navList: [],
      curNav: "/home",
      curSubNav: "",
      bannerList: [],
      isFixed: false,
      adMsg: {},
      adState: true,
    };
  },
  methods: {
    closeAd() {
      this.adState = false;
    },
    async getAdMsg() {
      let res = await this.$api.indexCollect();
      // console.log(res);
      this.adMsg = res.data.adv;
    },
    navClick(index, item) {
      this.curNav = item.uri;
      // console.log(this.bannerList);
      bannerSwiper.destroy();
      this.getMenuList();
    },
    async getMenuList() {
      let res = await this.$api.siteMenu();
      this.navList = res.data;
      await res.data.map((i, v) => {
        if (this.$route.name == "newsDetail" && i.uri == "/news") {
          this.bannerList = i.banners;
        } else if (i.uri == this.$route.path) {
          this.bannerList = i.banners;
        } else {
          i.children.map((x, y) => {
            if (x.uri == this.$route.path) {
              this.bannerList = x.banners;
            }
          });
        }
      });
      bannerSwiper = new Swiper(".banner-swiper", {
        loop: false, // 循环模式选项
        //自动播放
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        speed: 1000,
        grabCursor: true,
        watchSlidesProgress: true,
        mousewheelControl: true,
        observer: true,
        // 如果需要分页器
        // watchSlidesProgress: true,
        pagination: {
          el: ".banner-swiper .swiper-pagination",
          clickable: true,
        },
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".banner-swiper .swiper-button-next",
          prevEl: ".banner-swiper .swiper-button-prev",
        },
        on: {
          init: function () { },
          slideChangeTransitionEnd: function () {
            $(".banner-swiper .swiper-pagination .swiper-pagination-bullet-active")
              .addClass("on")
              .siblings()
              .removeClass("on");
          },
          autoplay: function (e) {
            if ($(".swiper-slide-video").parent().hasClass("swiper-slide-active")) {
              // e.autoplay.stop();
              // var videoElement = document.getElementsByClassName("swiper-slide-video");
              // videoElement.play();
            } else {
              // e.autoplay.start();
            }
          },
        },
      });
      $(function () {
        $(".banner-swiper .swiper-pagination .swiper-pagination-bullet-actibe").addClass(
          "on"
        );
        if ($(".swiper-slide-video").parent().hasClass("swiper-slide-active")) {
          console.log(1111);
          // bannerSwiper.autoplay.stop();
        }
        $(".swiper-slide-video").on("ended", function () {
          // bannerSwiper.autoplay.start();
        })
      });
    },
    handleScroll() {
      let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop; //滚动高度
      if (scrollHeight >= 300) {
        this.isFixed = true;
      } else {
        this.isFixed = false;
      }
    },
    extendSubMenu(item) {
      this.curSubNav = item.id;
    },
  },
  created() {
    let curNav = localStorage.getItem("curNav") || "/home";
    this.curNav = curNav;
  },
  mounted() {
    this.getMenuList();
    this.getAdMsg();
    this.$nextTick(() => {
      window.addEventListener("scroll", this.handleScroll);
      $(function () {
        $("body").click(function () {
          $("html").removeClass("active"),
            $(this)
              .find(".header-m")
              .find(".nav")
              .children("li")
              .removeClass("active")
              .find(".sub-nav")
              .hide(),
            $(this)
              .find(".main-nav-m")
              .find("ul")
              .slideUp()
              .siblings(".title")
              .removeClass("active");
        }),
          $("body")
            .children()
            .click(function () { }),
          $(".m-menu-b").click(function () {
            return (
              $("html").toggleClass("active"),
              $(".main-nav-m ul").hide(),
              $(".main-nav-m .title").removeClass("active"),
              !1
            );
          }),
          $(".main-nav-m .title").click(function () {
            return $(this).toggleClass("active").siblings("ul").stop().slideToggle(), !1;
          });
      });
    });
  },
};
</script>
<style>
.ad {
  position: relative;
  background: #fff4c7;
}

.ad-img {
  width: 1300px;
  display: block;
  margin: 0 auto;
  position: relative;
}

.ad-img img {
  display: block;
  margin: 0 auto;
  display: block;
}

.ad-close {
  position: absolute;
  right: -10px;
  top: 5%;
  z-index: 3;
  transform: scale(0.8);
}

.banner {
  height: 17.72rem;
  background: #f9f9f9;
  position: relative;
}

.banner.index {
  height: 100vh;
}

.banner img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border: 0 none;
}

.banner .swiper-slide-video {
  width: 100%;
}

.banner .swiper-button-prev {
  background-image: url("../assets/img/icon-prev-btn.png");
  left: 5%;
}

.banner .swiper-button-next {
  background-image: url("../assets/img/icon-next-btn.png");
  right: 5%;
}

.banner .swiper-button-next,
.banner .swiper-button-prev {
  background-size: 100% 100%;
  width: 1.84rem;
  height: 1.84rem;
}

.banner .swiper-pagination {
  outline: none;
  position: absolute;
  bottom: 20px;
  left: 0%;
  width: 100%;
  color: #fff;
  z-index: 5;
  text-align: center;
}

.banner .swiper-pagination .swiper-pagination-bullet {
  position: relative;
  margin: 0 5px;
  width: 60px;
  height: 4px;
  line-height: 20px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 0;
  opacity: 1;
  transition: all 0.5s ease;
}

.banner .swiper-pagination .swiper-pagination-bullet::before {
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  height: 4px;
  width: 0;
  background: #fff;
}

.banner .swiper-pagination .swiper-pagination-bullet.on:before {
  width: 100%;
  transition: all 5s linear;
}
</style>

<style scoped>
#header {
  transition: all ease 0.6s;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 99;
}

#header.top {
  top: 430px;
}

#header.active {
  background: rgba(0, 0, 0, 0.3);
  transition: all ease 0.6s;
  top: 0;
}

/* 导航栏 */
.pc-nav {
  width: 90%;
  height: 110px;
}

.pc-nav .nav-logo {
  width: 9.89rem;
  height: 100%;
  float: left;
  position: relative;
  display: flex;
  align-items: center;
}

.nav-fixed .nav-wrapper {
  line-height: 50px;
}

.pc-nav .nav-wrapper {
  line-height: 110px;
  float: right;
  margin: 0;
}

.pc-nav .nav-wrapper>li {
  float: left;
  margin: 0 15px;
  position: relative;
}

.pc-nav .nav-wrapper>li>a {
  color: #fff;
  font-size: 0.43rem;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}

.pc-nav .nav-wrapper>li>a>i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #fff;
}

.pc-nav .nav-wrapper>li>a>span {
  font-size: 12px;
  transition: transform ease 0.5s;
}

.pc-nav .nav-wrapper>li>a:hover {
  color: #fff;
  text-decoration: none;
}

.pc-nav .nav-wrapper>li>a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

.pc-nav .nav-wrapper>li>a:hover span {
  transform: rotate(180deg);
}

.pc-nav .nav-wrapper>li.active>a {
  color: #fff;
  text-decoration: none;
  border-bottom: 2px solid #fff;
}

.pc-nav .nav-wrapper>li>dl {
  display: none;
  position: absolute;
  width: 170px;
  top: 80%;
  left: 50%;
  margin-left: -85px;
  z-index: 999999;
  background: #fff;
}

.pc-nav .nav-wrapper>li>dl>dt {}

.pc-nav .nav-wrapper>li>dl>dt>a {
  display: block;
  width: 100%;
  width: 100%;
  height: 1.2rem;
  line-height: 1.2rem;
  font-size: 0.43rem;
  text-align: center;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
.pc-nav .nav-wrapper>li>dl>dt>a:hover {
  text-decoration: none;
}

/* 导航栏 滑上一级导航显示二级导航 */
.pc-nav .nav-wrapper>li:hover dl {
  display: block;
}

.pc-nav .nav-wrapper>li>dl>dt:hover {
  cursor: pointer;
  color: #555;
  background: #e7e7e7;
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .banner {
    height: 10rem;
  }
}

.header-m {
  display: none;
}

@media (max-width: 1200px) {
  .pc-nav {
    display: none;
  }

  .banner {
    margin-top: 70px;
  }

  .header-m {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 70px;
    background: #fff;
    display: block;
  }

  .header-m::after {
    display: none;
    position: fixed;
    content: "";
    top: 70px;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }

  .header-m .logo {
    position: absolute;
    left: 5%;
    height: 70px;
    line-height: 70px;
    z-index: 1001;
  }

  .header-m .logo img {
    height: 80%;
    margin-top: 10%;
  }

  .header-m .m-menu-b {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    width: 60px;
    height: 70px;
    cursor: pointer;
  }

  .header-m .m-menu-b::before,
  .header-m .m-menu-b::after {
    position: absolute;
    content: "";
    top: 50%;
    left: calc(35px / 2);
    width: 25px;
    height: 1px;
    z-index: 999;
    transition: all 0.3s ease-out 0.3s;
    -webkit-transition: all 0.3s ease-out 0.3s;
    background: #222;
  }

  .header-m .m-menu-b::before {
    transform: translateY(-4px) rotate(0);
    -webkit-transform: translateY(-4px) rotate(0);
  }

  .header-m .m-menu-b::after {
    transform: translateY(4px) rotate(0);
    -webkit-transform: translateY(4px) rotate(0);
  }

  .header-m .m-menu {
    display: none;
    z-index: 888;
    position: fixed;
    width: 100%;
    width: 260px;
    height: 100%;
    top: 0;
    left: -260px;
    opacity: 1;
    background: #fafafa;
    text-align: left;
    padding-top: 70px;
  }

  .header-m .m-menu::after {
    position: absolute;
    top: 70px;
    content: "";
    width: 100%;
    height: 1px;
    background: #ebebeb;
  }

  .header-m .nav {
    height: calc(100% - 82px);
    overflow-x: hidden;
    overflow-y: auto;
  }

  .header-m .nav>li {
    border-bottom: 1px solid #ebebeb;
    animation: resize 0.5s both;
    -webkit-animation: resize 0.5s both;
  }

  .header-m .nav>li>a {
    position: relative;
    display: block;
    width: 100%;
    font-size: 15px;
    padding: 0 40px;
    color: #666;
    vertical-align: middle;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-wrap: break-word;
    overflow: hidden;
    height: 50px;
    line-height: 50px;
  }

  .header-m .nav>li>a::after {
    position: absolute;
    content: "";
    left: 20px;
    top: 50%;
    width: 8px;
    height: 8px;
    margin-top: -5px;
    border: 1px solid #999;
    border-radius: 50%;
    background: transparent;
    transition: all 0.3s;
    -webkit-transition: all 0.3s;
  }

  .header-m .nav>li .sub-nav {
    display: none;
  }

  .header-m .nav>li .sub-nav.active {
    display: block !important;
  }

  .header-m .nav>li .sub-nav a {
    position: relative;
    display: block;
    line-height: 24px;
    padding: 12px 40px;
    background: #f2f2f2;
    color: #4e4e4e;
  }

  .header-m .nav>li .sub-nav a::before,
  .header-m .nav>li .sub-nav a::after {
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    left: 20px;
    top: 20px;
    border: 5px solid transparent;
    overflow: hidden;
    transition: all 0.3s;
    -webkit-transition: all 0.3s;
  }

  .header-m .nav>li .sub-nav a::before {
    left: 21px;
    border-left: 5px solid #555;
  }

  .header-m .nav>li .sub-nav a::after {
    border-left: 5px #ebebeb solid;
  }

  .header-m .nav>li.cur {
    position: relative;
  }

  .header-m .nav>li.cur .sub-nav-extend {
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 0;
    width: 25%;
    height: 50px;
    z-index: 3;
  }

  .header-m .nav>li.cur .sub-nav-extend::after,
  .header-m .nav>li.cur .sub-nav-extend::before {
    position: absolute;
    content: "";
    background: #999;
    transition: all 0.5s;
    -webkit-transition: all 0.5s;
  }

  .header-m .nav>li.cur .sub-nav-extend::before {
    top: 19px;
    right: 25px;
    width: 2px;
    height: 12px;
  }

  .header-m .nav>li.cur .sub-nav-extend::after {
    top: 24px;
    right: 20px;
    width: 12px;
    height: 2px;
  }

  .header-m .nav>li.active .sub-nav-extend::after {
    background: #fff;
  }

  .header-m .nav>li.active .sub-nav-extend::before {
    height: 0;
  }

  .header-m .nav>li.active>a {
    color: #fff;
    background: #e70;
  }

  .header-m .nav>li.active>a::after {
    border-color: #fff;
    background: #fff;
  }

  .header-m .nav>li.active .sub-nav li {
    animation: ReturnToNormal 0.5s both;
    -webkit-animation: ReturnToNormal 0.5s both;
  }

  html.active {
    height: 100%;
    overflow: hidden;
  }

  html.active body {
    height: 100%;
    overflow: hidden;
  }

  html.active .header-m {
    background: #fafafa;
  }

  html.active .header-m::after {
    display: block;
  }

  html.active .header-m .m-menu-b::before,
  html.active .header-m .m-menu-b::after {
    background: #000;
  }

  html.active .header-m .m-menu-b::before {
    transform: translateY(0) rotate(225deg);
    -webkit-transform: translateY(0) rotate(225deg);
  }

  html.active .header-m .m-menu-b::after {
    transform: translateY(0) rotate(-225deg);
    -webkit-transform: translateY(0) rotate(-225deg);
  }

  html.active .header-m .m-menu {
    display: block;
    left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue